import * as Sentry from "@sentry/react";

const isGoogleAnalyticsError = (event) => {
  const exception = event?.exception?.values?.[0];
  const frames = exception?.stacktrace?.frames || [];
  
  return frames.some(frame =>
    frame?.filename?.includes('google-analytics.com/analytics.js')
  );
};

const isSwiperCssModeError = (event) => {
  const exception = event?.exception?.values?.[0];
  // const frames = exception?.stacktrace?.frames || [];

  return (
    exception?.value?.includes("cssMode") &&
    exception?.value?.includes("Cannot read properties of undefined")
  );
};

const isTurnstileTimeoutError = (event) => {
  const exception = event?.exception?.values?.[0];
  const frames = exception?.stacktrace?.frames || [];
  
  const fromTurnstile = frames.some(frame =>
    frame?.filename?.includes('react-turnstile'))
  
  return (
    exception?.value?.includes("Timeout") &&
    fromTurnstile
  );
};

const isAxiosNetworkError = (event) => {
  const exception = event?.exception?.values?.[0];

  return (
    exception?.type?.includes("AxiosError") &&
    exception?.value?.includes("Network Error")
  );
};

if (process.env.REACT_APP_MODE === "prod") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    beforeSend(event) {
      const googleAnalyticsError = isGoogleAnalyticsError(event);
      const swiperCssModeError = isSwiperCssModeError(event);
      const turnstileTimeoutError = isTurnstileTimeoutError(event);
      const networkError = isAxiosNetworkError(event);
      
      const isShouldIgnore = googleAnalyticsError
        || swiperCssModeError
        || turnstileTimeoutError
        || networkError;
      
      return isShouldIgnore ? null : event;
    },
  });
}
